import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { travelRepository } from '@webapp/modules/expense/data-access/repositories/TravelRepository'
import { travelQueryConfig } from '@webapp/modules/expense/query-configs/travel'

export interface BatchApproveTravelItem {
  travelId: number
  approverId: Nullable<number>
}

export const useMutateBatchApproveTravels = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, BatchApproveTravelItem[]>({
    // BHV-034: every item is posted with force_approve: false
    mutationFn: (items) =>
      travelRepository.approve(
        items.map((item) => ({ ...item, forceApprove: false }))
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: travelQueryConfig.approvableListBase().queryKey,
      })
    },
  })

  return {
    batchApprove: (items: BatchApproveTravelItem[]) =>
      mutation.mutateAsync(items),
    isApproving: mutation.isLoading,
  }
}
